import script from "./MoveSort.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveSort.vue?vue&type=script&setup=true&lang=js"

import "./MoveSort.vue?vue&type=style&index=0&id=d06b20e0&lang=stylus"

const __exports__ = script;

export default __exports__